/*
 * @module Custom
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from "../../helpers/helper";

export default {
    mixins: [mixin],
    namespaced: true,
    state: {
        moduleType: 3, // 1 mapping, 2 auction, 3 custom

        inputs: [],
        cpt_inputs: [],
        roi_: 0,
        roe_: 0,
        buildingId: null,
        showModal: false,
        formData: [
            {
                address: 'fafa'
            }
        ],
        myDate: null,
        myErrors: [],
        saveOk: false,
        saveOkCpt: false,
        Regione: '',
        regionList: [],
        cityList: [],
        cityID: 0,
        mappedBuilding: [],
        mappingId: 0,
        resourceId: 0,
        zoneId: 0,
        fromCustom: 0,
        customOperationId: 0,
        customId: 0,
        operationId: 0,
        showCustomIncome: false,
        showModalUpload: false,
        myFileUpload: null,
        myDescriptionUpload: null,
        myFileIdUpload: null,
        fileList: [],
        imagesList: [],
        countImages: [],
        fileId: null,
        fileData: [],

        showModalConfigure: false,

        // auction
        fixed_acquisto_in_asta_1: 0,
        fixed_acquisto_in_asta_2: 0,
        fixed_acquisto_in_asta_3: 0,
        fixed_acquisto_in_asta_4: 0,
        fixed_revenue_1: 0,
        fixed_revenue_2: 0,
        fixed_revenue_3: 0,
        fixed_revenue_4: 0,

        templateName: '',

        templateId: 0,
        showHideModalDelete: false,
        selectedTemplate: 0,
        agency_ven_4: 0,
        agency_4: 0,
        costs_4: 0,
        fixed_profit_4: 0,
        notOpenConfigModal: true,
        closedOperation: false,
        bread_list: [],
        bread_active: {'label': 'Nuova operazione'}


    },
    getters: {
        getField
    },
    mutations: {
        updateField,

        closeOperationSet: function (state, boolean) {
            state.closedOperation = boolean;
        },

        showModalUploadSet: function (state) {
            state.showModalUpload = !state.showModalUpload;
        },

        showModalSet: function (state) {
            state.showModal = !state.showModal;
        },

        regionListSet: function (state, data) {
            state.regionList = data;
        },

        cityListSet: function (state, data) {
            state.cityList = data;
        },

        /**
         * used everywhere
         * @param state
         * @param boolean
         */
        saveOkSet: function (state, boolean) {
            state.saveOk = boolean;
        },

        saveOkCptSet: function (state, boolean) {
            state.saveOkCpt = boolean;
        },

        mappedBuildingSet: function (state, data) {
            state.mappedBuilding = data;
        },


        customOperationIdSet: function (state, data) {
            state.customOperationId = data;
        },

        zoneIdSet: function (state, data) {

            state.zoneId = data;
        },

        fromCustomSet: function (state, data) {
            state.fromCustom = data;
        },

        operationIdSet: function (state, data) {
            if (data != null) {
                state.operationId = data;
            }

        },

        showHideCustomIncomeSet: function (state) {
            state.showCustomIncome = !state.showCustomIncome;
        },

        defaultTemplateSet: function (state) {
            state.inputs = [];
            state.inputs.push(
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: ''},
            );
            state.templateName = '';
        },

        defaultIncomeForAuction: function (state) {
            state.inputs = [];
            state.inputs.push(
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Cancell. Ipot.'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Sgombro, fabbro'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Studio tecnico'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Tasse fisse'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Lavori ristrutt.'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Nuove utenze'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Oneri concessori'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Imprevisti'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'ACE'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Home staging'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Condominio'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Imposta sost.'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Assicurazione'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Perito'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Istruttoria'},
            );
        },

        defaultIncomeForMapping: function (state) {
            state.inputs = [];
            state.inputs.push(
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Tassa registro'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Tasse fisse'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Ristrutturazione'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Imprevisti'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Home Staging'},
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Contanti'},
            );
        },

        defaultIncomeForCustom: function (state) {
            state.inputs = [];
            state.inputs.push(
                {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: 'Tassa registro'},
            );
        },

        customFieldListSet: function (state, data) {
            if (data.length === 0) {
                state.inputs.push(
                    {importo_1: 0, importo_2: 0, importo_3: 0, importo_4: 0, etichetta: ''},
                );
            } else {
                state.inputs = data;
            }
        },

        customDataSet: function (state, data) {


            state.customId = data.id;
            state.formData.capital_invested = data.capitale_proprio;
            state.formData.revenue = data.ricavi;

            state.formData.percentage_estate_1 = data.percentuale_agenzia_1;
            state.formData.percentage_estate_2 = data.percentuale_agenzia_2;
            state.formData.percentage_estate_3 = data.percentuale_agenzia_3;
            state.formData.percentage_estate_4 = data.percentuale_agenzia_4;

            state.formData.percentage_estate_sell_1 = data.percentuale_agenzia_vendita_1;
            state.formData.percentage_estate_sell_2 = data.percentuale_agenzia_vendita_2;
            state.formData.percentage_estate_sell_3 = data.percentuale_agenzia_vendita_3;
            state.formData.percentage_estate_sell_4 = data.percentuale_agenzia_vendita_4;

            state.fixed_revenue_1 = data.asta_ricavi_1;
            state.fixed_revenue_2 = data.asta_ricavi_2;
            state.fixed_revenue_3 = data.asta_ricavi_3;
            state.fixed_revenue_4 = data.asta_ricavi_4;

            state.agency_4 = data.agenzia_acquisto_4;
            state.agency_ven_4 = data.agenzia_vendita_4;
            state.costs_4 = data.costi_4;
            state.fixed_profit_4 = data.utile_4;

            if (state.moduleType === 2) // auction
            {
                state.fixed_acquisto_in_asta_1 = data.asta_acquisto_in_asta_1;
                state.fixed_acquisto_in_asta_2 = data.asta_acquisto_in_asta_2;
                state.fixed_acquisto_in_asta_3 = data.asta_acquisto_in_asta_3;
                state.fixed_acquisto_in_asta_4 = data.asta_acquisto_in_asta_4;

            }


        },

        singleCustomFieldSet: function (state, data) {
            state.formData.editEtichetta = data.etichetta;
            state.formData.editImporto = data.importo;
        },

        populateModal: function (state) {
            state.formData.address = state.mappedBuilding.via;
            state.formData.mq = state.mappedBuilding.mq;
            state.formData.price = state.mappedBuilding.prezzo;
            state.formData.room = state.mappedBuilding.locali;
            state.formData.floor = state.mappedBuilding.piano;
            state.formData.lift = state.mappedBuilding.ascensori;
            state.formData.bathroom = state.mappedBuilding.bagni;
            state.formData.renovation = state.mappedBuilding.ristrutturazione;
            state.formData.date = state.mappedBuilding.data;
            state.formData.link = state.mappedBuilding.myLink;
            state.formData.note = state.mappedBuilding.note;
            state.formData.zone = state.mappedBuilding.zone;
            state.formData.macrozone = state.mappedBuilding.macrozone;
            state.formData.microzone = state.mappedBuilding.microzone;
            state.Regione = state.mappedBuilding.region;
            state.formData.cityID = state.mappedBuilding.city_id;
            // state.formData.capital_invested = state.mappedBuilding.capitale_proprio;
            //state.formData.revenue = state.mappedBuilding.revenue;
            state.myDate = state.mappedBuilding.data;
        },

        fileListSet: function (state, data) {
            state.fileList = data.docs;
            state.imagesList = data.images;
            state.countImages = data.countImages;
        },
        /*
         * Setting file for modal upload to modify/delete
         */
        singleFileSet: function (state, data) {
            state.fileData = data;
        },

        showModalConfigureSet: function (state) {
            if (state.notOpenConfigModal != true) {
                state.showModalConfigure = !state.showModalConfigure;
            }

        },

        moduleTypeSet: function (state, data) {
            state.moduleType = data;
        },

        resourceIdSet: function (state, data) {
            state.resourceId = data;
            state.mappingId = data;
        },


        templateSet: function (state, data) {
            state.templateName = data.templateName;
            state.templateId = data.id
        },

        showHideDeleteModalSet: function (state) {

            state.showHideModalDelete = !state.showHideModalDelete;
        }


    },
    actions: {

        regionList: function (state) {
            axios.get('/api/v1/custom/regionList')
                .then(function (response) {
                    state.commit('regionListSet', response.data);
                })
        },

        cityList: function (state) {
            axios.get('/api/v1/custom/cityList/' + state.state.Regione)
                .then(function (response) {
                    state.commit('cityListSet', response.data);
                })
        },

        showHideModal: function (state) {
            state.dispatch('initModalForm');
            state.commit('showModalSet');

        },

        saveData: function (state) {
            let initMappingId = state.state.mappingId;
            axios.post('/api/v1/custom/saveData', {
                via: state.state.formData.address,
                mq: state.state.formData.mq,
                prezzo: mixin.methods.REMOVE_DOT(state.state.formData.price),
                locali: state.state.formData.room,
                piano: state.state.formData.floor,
                ascensori: state.state.formData.lift,
                bagni: state.state.formData.bathroom,
                ristrutturazione: state.state.formData.renovation,
                data: state.state.myDate,
                link: state.state.formData.link,
                note: state.state.formData.note,
                active: 1,
                city_id: state.state.formData.cityID,
                region: state.state.Regione,
                zone: state.state.formData.zone,
                macrozone: state.state.formData.macrozone,
                microzone: state.state.formData.microzone,
                mapping_id: state.state.mappingId,
                custom_id: state.state.customOperationId,
                operation_id: state.state.operationId,
                zone_id: state.state.zoneId,
                fromCustom: state.state.fromCustom,
            })
                .then(function (response) {


                    if (state.state.mappingId > 0) {
                        state.commit('showModalSet');
                        state.dispatch('mappingDetail');
                    } else {
                        window.location.href = '/custom/' + response.data.mappingId + '/' + response.data.operationId;
                    }

                })
        },

        mappingDetail: function (state) {
            axios.get('/api/v1/custom/mappingDetail/' + state.state.mappingId)
                .then(function (response) {
                    state.commit('mappedBuildingSet', response.data);
                    state.commit('customfree/buildingDetailSet', response.data, {root: true});
                    state.commit('zoneIdSet', response.data.zone_id);
                    state.commit('fromCustomSet', response.data.fromCustom);
                    state.commit('customOperationIdSet', response.data.operation_id);
                    state.commit('operationIdSet', response.data.operation_id);
                    state.commit('populateModal');
                    state.dispatch('cityList');
                    state.dispatch('customData');

                })
        },

        saveCustomField: function (state) {

            axios.post('/api/v1/custom/saveCustomField', {
                'importo': mixin.methods.REMOVE_DOT(state.state.formData.custom_price),
                'etichetta': state.state.formData.custom_label,
                'custom_id': state.state.customOperationId,
            })
                .then(function () {
                    state.dispatch('customFieldList');
                    state.dispatch('clearForm');
                })
        },

        customData: function (state) {


            axios.get('/api/v1/custom/customData/' + state.state.customOperationId + '/' + state.state.moduleType)
                .then(function (response) {

                    state.commit('customDataSet', response.data);
                    state.dispatch('customFieldList');

                });
        },

        customFieldList: function (state) {
            axios.get('/api/v1/custom/customFieldList/' + state.state.customId)
                .then(function (response) {
                    if (response.data.length === 0) {
                        if (state.state.moduleType === 1) {
                            state.commit('defaultIncomeForMapping');
                        }

                        if (state.state.moduleType === 2) {
                            state.commit('defaultIncomeForAuction');
                        }

                        if (state.state.moduleType === 3) {
                            state.commit('defaultIncomeForCustom');
                        }
                    } else {
                        state.commit('customFieldListSet', response.data);
                    }
                    state.dispatch('resetCustomField');

                });
        },

        checkId: function (state, route) {
            if (route.id > 0) {
                state.commit('resourceIdSet', route.id);
                state.commit('operationIdSet', route.customId);
                state.dispatch('mappingDetail');
                state.commit('showHideCustomIncomeSet');
            }
        },

        /**
         * Update custom data from income card (three values)
         * @param state
         */
        updateCustomData: function (state) {
            axios.post('/api/v1/custom/updateCustomData', {
                'id': state.state.customOperationId,
                'capitale_proprio': mixin.methods.REMOVE_DOT(state.state.formData.capital_invested),
                'ricavi': mixin.methods.REMOVE_DOT(state.state.formData.revenue),
                'prezzo': mixin.methods.REMOVE_DOT(state.state.mappedBuilding.prezzo),
                'mappatura_id': state.state.mappingId,
            })
                .then(function () {
                    state.dispatch('mappingDetail');
                })

        },


        /**
         * Claring form everyWhere
         * @param state
         */
        clearForm: function (state) {
            for (let f in state.state.formData) {
                state.state.formData[f] = ' ';
            }
            state.state.Regione = ' ';
        },

        initModalForm: function (state) {
            state.state.formData.zone = ' ';
            state.state.formData.macrozone = ' ';
            state.state.formData.microzone = ' ';
            state.state.formData.address = ' ';
            state.state.formData.room = 0;
            state.state.formData.mq = 0;
            state.state.formData.floor = 0;
            state.state.formData.lift = ' ';
            state.state.formData.bathroom = 0;
            state.state.formData.renovation = ' ';
            state.state.formData.link = ' ';
            state.state.formData.link = ' ';
            state.state.formData.note = ' ';
        },

        /**
         * Used to show "saved" label everywhere
         * @param state
         */
        offMsg: function (state, data) {
            setTimeout(function () {
                state.commit('saveOkSet', false);
            }, 2000);

            setTimeout(function () {
                if (data.triggerShowHideModal === true) {
                    state.commit('showModalSet');
                }
            }, 1000)
        },

        offMsgCpt: function (state) {
            setTimeout(function () {
                state.commit('saveOkCptSet', false);
            }, 2000);
        },

        saveIncome: function (state) {


            if (state.state.moduleType === 2) {

                axios.post('/api/v1/custom/saveCustomField', {
                    customFields: state.state.inputs,
                    custom_id: state.state.customOperationId,
                    asta_acquisto_in_asta_1: mixin.methods.REMOVE_DOT(state.state.fixed_acquisto_in_asta_1),
                    asta_acquisto_in_asta_2: mixin.methods.REMOVE_DOT(state.state.fixed_acquisto_in_asta_2),
                    asta_acquisto_in_asta_3: mixin.methods.REMOVE_DOT(state.state.fixed_acquisto_in_asta_3),
                    asta_acquisto_in_asta_4: mixin.methods.REMOVE_DOT(state.state.fixed_acquisto_in_asta_4),
                    asta_ricavi_1: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_1),
                    asta_ricavi_2: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_2),
                    asta_ricavi_3: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_3),
                    asta_ricavi_4: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_4),
                    agenzia_acquisto_4: mixin.methods.REMOVE_DOT(state.state.agency_4),
                    agenzia_vendita_4: mixin.methods.REMOVE_DOT(state.state.agency_ven_4),
                    costi_4: mixin.methods.REMOVE_DOT(state.state.costs_4),
                    utile_4: mixin.methods.REMOVE_DOT(state.state.fixed_profit_4),
                    asta_id: state.state.auctionId,
                    module_type: state.state.moduleType,
                    percentage_tax_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_1),
                    percentage_tax_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_2),
                    percentage_tax_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_3),
                })
                    .then(function () {
                        state.commit('saveOkSet', true);
                        state.dispatch('offMsg', {triggerShowHideModal: false});
                    })
            }

            if (state.state.moduleType === 1 || state.state.moduleType === 3) {


                axios.post('/api/v1/custom/saveCustomField', {
                    customFields: state.state.inputs,
                    custom_id: state.state.customOperationId,
                    prezzo: mixin.methods.REMOVE_DOT(state.state.mappedBuilding.prezzo),
                    capitale_proprio: mixin.methods.REMOVE_DOT(state.state.formData.capital_invested),
                    asta_ricavi_1: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_1),
                    asta_ricavi_2: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_2),
                    asta_ricavi_3: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_3),
                    asta_ricavi_4: mixin.methods.REMOVE_DOT(state.state.fixed_revenue_4),
                    agenzia_acquisto_4: mixin.methods.REMOVE_DOT(state.state.agency_4),
                    agenzia_vendita_4: mixin.methods.REMOVE_DOT(state.state.agency_ven_4),
                    costi_4: mixin.methods.REMOVE_DOT(state.state.costs_4),
                    utile_4: mixin.methods.REMOVE_DOT(state.state.fixed_profit_4),

                    mappatura_id: state.state.resourceId,
                    module_type: state.state.moduleType
                })
                    .then(function () {
                        state.commit('saveOkSet', true);
                        state.dispatch('offMsg', {triggerShowHideModal: false});
                    })
            }

        },

        triggerModalUpload: function (state) {
            state.commit('showModalUploadSet');
        },

        sendUploadFile: function (state) {
            let forma = new FormData();
            forma.append('file', state.state.myFileUpload);
            forma.append('descrizione', state.state.myDescriptionUpload);
            forma.append('operazione_id', state.state.operationId);
            forma.append('id', state.state.myFileIdUpload);
            axios.post('/api/v1/custom/sendUploadFile', forma,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then(function (response) {
                    state.dispatch('triggerModalUpload');
                    state.dispatch('fileList');
                })
        },

        fileList: function (state) {
            axios.get('/api/v1/custom/fileList/' + state.state.operationId)
                .then(function (response) {
                    state.commit('fileListSet', response.data);
                })
        },

        removeFile: function (state) {
            axios.get('/api/v1/custom/removeFile/' + state.state.fileId)
                .then(function () {
                    state.dispatch('fileList');
                })
        },

        /*
         * Retrieve file used in modal upload to modify/delete it
         */
        retrieveFile: function (state, id) {
            axios.get('/api/v1/custom/retrieveFile/' + id)
                .then(function (response) {
                    state.commit('singleFileSet', response.data);
                    state.dispatch('upload/settingFileData', state.state.fileData, {root: true});
                    state.dispatch('triggerModalUpload')
                })
        },

        showHideModalConfigure: function (state) {
            state.commit('showModalConfigureSet');
        },

        settingIncomeForMapping: function (state, data) {
            state.commit('moduleTypeSet', 1); // 1 mapping, 2 auction, 3 custom
            state.commit('resourceIdSet', data.mappingId);
            axios.post('/api/v1/operation/createOrRetrieve/', {
                resourceId: data.mappingId,
                type: 1 // mapping
            })
                .then(function (response) {
                    state.commit('customOperationIdSet', response.data);
                    state.commit('showHideCustomIncomeSet');
                    state.dispatch('customData');
                });
            //state.commit('defaultIncomeForMapping');
        },

        settingIncomeForAuction: function (state, data) {
            state.commit('moduleTypeSet', 2); // 1 mapping, 2 auction, 3 custom
            state.commit('resourceIdSet', data.auctionId);


            axios.post('/api/v1/operation/createOrRetrieve/', {
                resourceId: data.auctionId,
                type: 2 // mapping
            })
                .then(function (response) {

                    state.commit('customOperationIdSet', response.data);
                    state.commit('showHideCustomIncomeSet');
                    state.dispatch('customData');
                });
        },

        // for template setting
        defaultTemplate: function (state) {
            state.commit('defaultTemplateSet');
        },

        // default template
        saveDefaultTemplate: function (state) {
            axios.post('/api/v1/custom/saveDefaultTemplate', {
                customFields: state.state.inputs,
                templateName: state.state.templateName,
                templateId: state.state.templateId
            })
                .then(function () {
                    state.dispatch('defaultTemplate');
                    state.dispatch('templateList');
                })
        },


        // default template
        editTemplate: function (state, data) {
            axios.get('/api/v1/custom/editTemplate/' + data.id)
                .then(function (response) {
                    state.commit('templateSet', {id: data.id, templateName: data.templateName});
                    state.commit('customFieldListSet', response.data);
                })
        },

        showHideDeleteModal: function (state) {
            state.commit('showHideDeleteModalSet');
        },


        resetCustomField: function (state) {
            if (state.state.selectedTemplate > 0) {
                axios.get('/api/v1/custom/editTemplate/' + state.state.selectedTemplate)
                    .then(function (response) {
                        state.commit('customFieldListSet', response.data);
                    })
            }
        },

        boxRoe: function (state, data) {
            state.state.roe_ = data;
        },

        boxRoi: function (state, data) {
            state.state.roi_ = data;
        },

        closeOrOpen: function (state, data) {
            axios.post('/api/v1/operation/close', {
                resourceId: data.resourceId,
                type: data.type
            })
                .then(function (response) {
                    state.commit('closeOperationSet', response.data);
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        isOperationClosed: function (state, data) {
            axios.get('/api/v1/operation/isClosed/' + data.resourceId + '/' + data.type)
                .then(function (response) {
                    state.commit('closeOperationSet', response.data);
                })

        },

        addTeamToOperation: function (state, data) {
            axios.get('/api/v1/team/addToOperation/' + data.resourceId + '/' + data.type   )
                .then(function(response){

                })
        }


    }
}